import { useState } from "react";
import { ImageOff } from "lucide-react";

// Renders supplied MyPandaX artwork; falls back to a clearly-labelled slot when the file is missing.
export default function VipArtwork({ src, alt, file, aspect = "aspect-[3/2]", fit = "object-cover", className = "", children }) {
  const [failed, setFailed] = useState(false);
  return (
    <div data-testid={`vip-artwork-${file}`} className={`relative overflow-hidden border border-white/10 bg-black ${aspect} ${className}`}>
      {failed ? (
        <div data-testid={`vip-artwork-${file}-missing`} className="absolute inset-0 grid place-items-center text-center px-6 bg-[radial-gradient(ellipse_at_top,rgba(225,29,72,0.18),transparent_60%)]">
          <div>
            <ImageOff size={28} className="mx-auto text-zinc-600 mb-3" />
            <div className="text-[10px] uppercase tracking-[0.3em] text-zinc-500">Artwork slot</div>
            <div className="text-sm text-zinc-300 mt-1 font-mono break-all">{file}.png</div>
            <div className="text-xs text-zinc-500 mt-2">Awaiting the supplied file — drops in here automatically.</div>
          </div>
        </div>
      ) : (
        <img src={src} alt={alt} onError={() => setFailed(true)} className={`absolute inset-0 w-full h-full ${fit}`} loading="lazy" />
      )}
      {!failed && children}
    </div>
  );
}
